const getValue = (array, key) => {
  const item = array?.find((item) => item.key === key);
  return item
    ? { value: item.value, title: item.title }
    : { value: '', title: '' };
};

export default getValue;
